import { render, staticRenderFns } from "./AllPeopleList.vue?vue&type=template&id=32598e77&scoped=true"
import script from "./AllPeopleList.vue?vue&type=script&lang=js"
export * from "./AllPeopleList.vue?vue&type=script&lang=js"
import style0 from "./AllPeopleList.vue?vue&type=style&index=0&id=32598e77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32598e77",
  null
  
)

export default component.exports